import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../lib/auth';

export default function PublicOnly({ redirectTo = '/dashboard' }) {
  if (isAuthenticated()) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}

